<template>
  <div class="comm-cat-pg-wrapper">
    <BreadCrumbs :crumbs="breadcrumbs" />
    <h1 class="cat-title">
      <template v-if="breadcrumbs?.length === 3">
        {{ breadcrumbs?.[2]?.title + ' ' + breadcrumbs?.[1]?.title }}
      </template>
      <template v-else-if="breadcrumbs?.length === 2">
        {{ breadcrumbs?.[0]?.title + ' ' + breadcrumbs?.[1]?.title }}
      </template>
      <template v-else>
        {{ category?.title ? category.title : title }}
      </template>
    </h1>
    <!-- <h1 class="cat-title">{{ `${category && category.title ? category.title + ' ' : ''}` + title }}</h1> -->
    <nav v-if="!category" class="subnav">
      <ul class="flex">
        <li v-for="item in state.navLinks" :key="item.url" :class="{ selected: checkSelected(item.url) }">
          <NuxtLink :to="localePath(item.url)">
            {{ item.title }}
          </NuxtLink>
        </li>
      </ul>
    </nav>
    <div class="posts-wrapper">
      <template v-if="items?.length">
        <PostItem v-for="(post, index) in items" :key="post.url + index" :post="post" :is-cat-page="true" />
      </template>
      <div v-else>
        <h2>No content available</h2>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CommunityCategory } from '~/types/contentstack';
import { useLocaleStore } from '~/store/locale';

const localePath = useLocalePath();
const localeStore = useLocaleStore();
const route = useRoute();

const props = defineProps({
  items: {
    type: Array as () => any[],
    default: () => [],
  },
  title: {
    type: String,
    required: true,
  },
  postType: {
    type: String,
    required: true,
  },
  category: {
    type: Object as () => CommunityCategory,
    default: undefined,
  },
});

const state = reactive({
  navLinks: [
    { title: 'Videos', url: '/community/video' },
    { title: 'Blog', url: '/community/blog' },
    { title: 'Events', url: '/community/event' },
  ],
});

const breadcrumbs = computed<any[]>(() => {
  const vals = [
    { title: 'Community', url: '/community' },
    { title: props.title, url: `/community/${props.postType}` },
  ];
  if (props.category)
    vals.push({ title: props.category?.title, url: `/community/${props.postType}${props.category?.url}` });
  return vals;
});

function checkSelected(url: string): boolean {
  return route.path === `/${localeStore.langCode}${url}`;
}
</script>

<style lang="scss" scoped>
.comm-cat-pg-wrapper {
  width: 100%;
  max-width: calc(local-vars.$xxl-content-max-width - 4rem);
  margin: #{local-functions.rem-calc(15)} auto;
}
.breadcrumbs {
  padding-left: 15px;
}
.cat-title {
  padding-left: 16px;
  margin-bottom: 1.5rem;
}
.subnav {
  width: 100%;
  margin-bottom: 2.5rem;
  font-weight: 500;
  font-size: 1rem;
  border-bottom: 1px solid $color-neutral-cool-200;
  li {
    padding: 0.5rem 1rem;
    a {
      color: $color-neutral-cool-900;
    }
    &.selected {
      a {
        color: $color-primary-600;
      }

      border-bottom: 2px solid $color-primary-600;
    }
  }
  @include local-mixins.desktop {
    li {
      padding: 0.5rem 1.5rem;
    }
  }
}
.posts-wrapper {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 2.5rem;

  @include local-mixins.tablet {
    grid-template-columns: calc(50% - 1.25rem) calc(50% - 1.25rem);
  }

  @include local-mixins.desktop {
    grid-template-columns: calc(33% - 1.25rem) calc(33% - 1.25rem) calc(33% - 1.25rem);
  }
}
</style>
